<template lang="html">
  <div class="prt-expense-summary" :class="{cwb}">
    <span class="title">{{title}}</span>
    <span class="amount" :class="{positive: amount >= 0}">{{amountWithCurrency}}</span>
  </div>
</template>

<script>
export default {
  computed: {
    amountWithCurrency() {
      const symbol = this.$store.state.preferences.currencySymbol;
      let transformedString;

      if (this.$store.state.preferences.suffixCurrencySymbol) {
        transformedString = `${this.amount < 0 && this.cwb ? '-' : ''} ${Math.abs(this.amount).toFixed(2)} ${symbol}`;
      } else {
        transformedString = `${this.amount < 0 && this.cwb ? '-' : ''} ${symbol} ${Math.abs(this.amount).toFixed(2)}`;
      }

      return transformedString;
    },
  },
  props: {
    amount: {
      type: Number,
      required: true,
    },
    cwb: Boolean,
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-expense-summary
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column

    .title
      text-transform: uppercase
      letter-spacing: 1px
      font-size: 10px
      color: black-54
      font-weight: bold
      display: block

    .amount
      font-size: 20px
      color: negative
      display: block

      &.positive
        color: positive

    &.cwb
      .title
        color: white-70

      .amount
        color: white
        font-weight: bold
        font-size: 26px
</style>
